// extracted by mini-css-extract-plugin
module.exports = {"container":"single-accommodations-point-page_container__RoZwK","icon":"single-accommodations-point-page_icon__iaWvf"};